import type {State} from '../../../reducers/types'

import type {ErrorAnswer} from './Listings/Rules/Rules.types'

export const getIsAnyActionPerforming = (state: State) =>
  state.cleanupPolicies.isAnyActionPerforming
export const getCustomError: (arg0: State) => ErrorAnswer | null = ({cleanupPolicies}) =>
  cleanupPolicies.error
